import { gql } from '@apollo/client';
import { WorkspaceRowFragment } from '../../../utils/apollo/workspaces/fragments';
import { UserFragment } from '../../../utils/apollo/fragments';

export default gql`
  query getChannel(
    $workspaceId: ID!
    $since: Int
    $channelId: ID!
    $pagination: Pagination!
    $userStates: [UserState!]
  ) {
    users(pagination: $pagination, includes: [], userStates: $userStates) {
      entities {
        ...UserFields
      }
    }

    workspace(id: $workspaceId) {
      id
      name
      badge(since: $since)
      main {
        id
        lastViewedAt
      }
      directs {
        id
        lastViewedAt
      }
      rows {
        ...WorkspaceRowFields
      }
    }

    channel(id: $channelId) {
      id
      name
      kind
      badge(since: $since)
      lastViewedAt
      users {
        ...UserFields
      }
      messages(since: $since) {
        id
        parent
        creator {
          id
          picture
          name
        }
        createdAt
        text
        formatted
        tags {
          id
          kind
          state
        }
        analysis {
          id
          display
          start
          end
        }
        annotation {
          url
          imageUrl
        }
      }
    }
  }
  ${WorkspaceRowFragment}
  ${UserFragment}
`;
